document.addEventListener('click', function(e){
  var head = e.target.closest('.acc-head');
  if(head) head.closest('.acc-item').classList.toggle('open');
});

// ---------- Announcement bar slider ----------
function initAnnouncementSlider(){
  document.querySelectorAll('announcement-slider').forEach(function(bar){
    if(bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    var slides = bar.querySelectorAll('.announce-slide');
    if(slides.length < 2) return;
    var index = 0;
    function show(i){
      slides.forEach(function(s){ s.classList.remove('is-active'); });
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }
    bar.querySelector('[data-prev]').addEventListener('click', function(){ show(index - 1); });
    bar.querySelector('[data-next]').addEventListener('click', function(){ show(index + 1); });
    setInterval(function(){ show(index + 1); }, 2000);
  });
}
if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', initAnnouncementSlider);
} else {
  initAnnouncementSlider();
}
// Re-init whenever Shopify's theme editor swaps section markup via AJAX
document.addEventListener('shopify:section:load', initAnnouncementSlider);
